import styled, { css } from 'styled-components'
import { TextAreaInput } from 'common-components'
import { disableSomeContentStyles } from 'styles/mixins'

import { CharacterCountIndicator } from 'common-components'
import { COLORS } from 'consts/colors'

const TTS_TEXT_AREA_PADDING = 12

interface ITextAreaProps {
  $isFocused?: boolean
  $isError?: boolean
  $isActive?: boolean
  $isGenerated?: boolean
  $minHeight?: number
  $isLoading?: boolean
}

export const TextToSpeechTextArea = styled.div<ITextAreaProps>`
  position: relative;
  height: auto;
  width: 100%;
  display: flex;
  ${({ $isLoading }) => $isLoading && disableSomeContentStyles()}
`

//this block is simulating the textarea bottom padding
//it's needed to make the textarea look like text doesnt overflows the bottom border
export const TextAreaPseudoBlock = styled.div<ITextAreaProps>`
  position: absolute;
  bottom: 1px;
  right: ${TTS_TEXT_AREA_PADDING}px;
  width: calc(100% - ${TTS_TEXT_AREA_PADDING * 2}px);
  height: ${TTS_TEXT_AREA_PADDING}px;
  background-color: ${props =>
    props.$isGenerated || props.$isActive ? COLORS.white : COLORS.primaryLight};
  pointer-events: none;
`

export const TextArea = styled(TextAreaInput)<ITextAreaProps>`
  position: relative;
  font-weight: 500;
  font-size: 14px;
  width: 100%;
  line-height: 17px;
  padding-right: 9px;

  &::placeholder {
    color: ${COLORS.secondarySemiLight};
  }

  ${({ $isActive, $isFocused, $isError, $isGenerated, $minHeight }) => {
    if ($isActive) {
      return css`
        min-height: ${$minHeight}px !important;
        background-color: ${COLORS.white};
        color: ${COLORS.secondarySemiDark};

        ${$isFocused
          ? !$isError &&
            css`
              border: 1px solid ${COLORS.primaryDark};
              box-shadow: 0 0 0 1px ${COLORS.primaryTint};

              &:hover {
                border: 1px solid ${COLORS.primaryDark};
              }
            `
          : css`
              overflow: hidden !important;
            `}
      `
    }

    return css`
      height: 40px !important;
      background-color: ${$isGenerated ? COLORS.white : COLORS.primaryLight};
    `
  }}
`

export const TextCharacterCountIndicator = styled(
  CharacterCountIndicator
)<ITextAreaProps>`
  height: ${({ $isActive }) => ($isActive ? 'auto' : '0')};
  margin-top: ${({ $isActive }) => ($isActive ? '4px' : '0')};
  overflow: hidden;
  font-size: 10px;
  font-weight: 500;
  opacity: ${({ $isFocused }) => ($isFocused ? 1 : 0)};
  transition: opacity 0.2s linear;
  transition:
    height 0.2s linear,
    margin-top 0.2s linear;
`
